/**
 * Container component sitting directly below the router. It fires a Snowplow
 * page view on initial mount and on every route (pathname) change, then renders
 * the rest of the app via AppInitialization.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/History_API
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import AppInitialization from "../startup/AppInitialization.component.jsx";
import * as reduxSelectors from '../store/application.reducers';
import {getSnowplowContexts} from "utils/snowplow";
import {withRouter} from "components/router/withRouter.tsx";


export class VirtualPageTracker extends Component {

    static propTypes = {
        location: PropTypes.object, // 'target' path from the router
        userConfiguration: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.trackPageView();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.trackPageView();
        }
    }

    trackPageView() {
        window.snowplow('trackPageView', {
            'title': null,
            'context': this.props.userConfiguration ? getSnowplowContexts(this.props.userConfiguration) : []
        });
    }

    render() {
        return <AppInitialization {...this.props} />;
    }

}

const mapStateToProps = function (store) {
    return {
        userConfiguration: reduxSelectors.getUsersData(store)
    };
};

const VirtualPageTrackerWithLocation = withRouter(VirtualPageTracker);
export default connect(mapStateToProps)(VirtualPageTrackerWithLocation);
